const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsSolutionsArchitectAssociate = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Building Strong Foundations in AWS Architecture
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          The AWS Certified Solutions Architect – Associate certification established a solid foundation
          in designing scalable, reliable, and cost-efficient cloud systems on AWS.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsSolutionsArchitectAssociate.png"
          alt="AWS Certified Solutions Architect Associate"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified Solutions Architect – Associate
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification focuses on core architectural principles and practical AWS usage,
          forming the foundation for designing cloud-based systems.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          It ensures a deep understanding of how AWS services interact and how to build systems
          that are scalable, resilient, and efficient.
        </p>
      </div>


      {/* CORE CAPABILITIES */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Core Architecture Foundations
        </h2>

        <div style={gridStyle}>
          {[
            "Designing architectures using core AWS services (EC2, S3, RDS, VPC)",
            "Building highly available and fault-tolerant systems",
            "Designing scalable solutions for changing workloads",
            "Applying cost optimization principles in architecture design",
            "Implementing secure access using IAM and best practices",
            "Understanding networking and VPC architecture fundamentals",
            "Designing storage solutions for different use cases",
            "Integrating multiple AWS services into cohesive systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* WHAT THIS ENABLES */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          What This Foundation Enables
        </h2>

        <div style={gridStyle}>
          {[
            "Designing reliable cloud applications from the ground up",
            "Understanding how AWS services interact within architectures",
            "Building systems that can scale with business growth",
            "Avoiding common architectural mistakes early in development",
            "Creating maintainable and well-structured cloud solutions"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* PROGRESSION 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          From Foundations to Advanced Architecture
        </h2>

        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification was the starting point for developing advanced architectural expertise.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          It was later expanded through the <strong>Solutions Architect – Professional</strong> certification,
          building on these foundations to design complex, distributed, and production-grade systems.
        </p>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Strong architecture is built on solid fundamentals.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          Understanding core AWS services and design principles is essential before moving into
          complex, large-scale systems.
        </p>
      </div>


      {/* CTA */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Build Your AWS Architecture on Strong Foundations
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s design scalable and reliable cloud solutions from the ground up.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Start Building on AWS →
        </a>
      </div>

    </div>
  );
};

export default AwsSolutionsArchitectAssociate;